
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
  import {
    orderSettlesupportList
  } from "@/api/order"
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate
    }
  })

  export default class ProductList extends Vue {
    private orderNo = ''
    private keywords = ''
    private SupportNo = ''
    private SupportType = null
    private SupportTypelist = [
      {value:null,label:'全部'},
      {value:2,label:'退货退款'},
      {value:999,label:'仅退款-未收到货'},
      {value:3,label:'仅退款-已收到货'},
      {value:1,label:'换货'},
    ]
    private tablelist:any = []
    private tableloading = false
    private pageSize = 10
    private pageNo = 1
    private total = 0

    private mounted () {
      this.gettablelist()
    }


    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let data:any = {
          ...this.$route.query,
          OrderNo:this.orderNo,
          ProductInfo:this.keywords,
          SupportNo:this.SupportNo,
          SupportType:this.SupportType==999?3:this.SupportType,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize,
          ProductState:this.SupportType==3?0:(this.SupportType==999?1:'')
        }
        let res:any = await orderSettlesupportList(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private clearSearch(){
      this.orderNo = ''
      this.keywords = ''
      this.SupportNo = ''
      this.SupportType = null
      this.doSearch()
    }
    private exportfile(){
      let url = location.origin + '/pc/finance/orderSettle/supportList'
      url += '?FinanceOrderSettleRecordId=' + (this.$route.query.FinanceOrderSettleRecordId||'')
      url += '&ProviderId=' + (this.$route.query.ProviderId||'')
      url += '&StartTime=' + (this.$route.query.StartTime||'')
      url += '&EndTime=' + (this.$route.query.EndTime||'')
      url += '&OrderNo=' + this.orderNo
      url += '&ProductInfo=' + encodeURIComponent(this.keywords)
      url += '&SupportNo=' + this.SupportNo
      url += '&SupportType=' + (this.SupportType==null?'':(this.SupportType==999?3:this.SupportType))
      url += '&ProductState=' + (this.SupportType==3?0:(this.SupportType==999?1:''))
      window.open(url)
    }
  }
